import { Stack, Typography } from "@mui/material";
import { Box, Container } from "@mui/system";
import React from "react";
import global from "../Components/Assets/global.png";
import binance from "../Components/Assets/binance.png";
import met from "../Components/Assets/met.png";

const Map = () => {
  return (
    <>
      <Box sx={{ backgroundColor: "#0D0D0D",padding:"50px 0px"}}>
        <Container>
          <Typography
            sx={{
              fontSize: { xs: "15px", md: "24px" },
              fontWeight: "400",
              lineHeight: "36px",
              letterSpacing: "0em",
              textAlign: "center",
              color: " rgba(128, 171, 158, 1)",
            }}
          >
            Achievements
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: "15px", md: "24px" },
              fontWeight: "700",
              lineHeight: "54px",
              letterSpacing: "0em",
              textAlign: "center",
              color: " rgba(245, 251, 242, 1)",
            }}
          >
            Full Decentralised and Currency Security
          </Typography>
          <Stack
            direction="row"
            justifyContent="center"
            spacing="20%"
            color="#fff"
            textAlign="center"
           
          >
            <Box>
              <Typography
                sx={{
                  fontWeight: "700px",
                  fontSize: { xs: "20px", md: "36px" },
                  lineHeight: "54px",
                  color: "rgba(0, 227, 165, 1)",
                }}
              >
                1M+
              </Typography>
              <Typography
                sx={{
                  fontWeight: "400px",
                  fontSize:{xs:"9px",md:"18px"},
                  lineHeight: "27px",
                  color: "rgba(158, 158, 158, 1)",
                }}
              >
                Happy Users
              </Typography>
            </Box>
            <Box>
              <Typography
                sx={{
                  fontWeight: "700px",
                  fontSize: { xs: "20px", md: "36px" },
                  lineHeight: "54px",
                  color: "rgba(0, 227, 165, 1)",
                }}
              >
                200K+
              </Typography>
              <Typography
                sx={{
                  fontWeight: "400px",
                  fontSize:{xs:"9px",md:"18px"},
                  lineHeight: "27px",
                  color: "rgba(158, 158, 158, 1)",
                }}
              >
                Community Assets
              </Typography>
            </Box>
            <Box>
              <Typography
                sx={{
                  fontWeight: "700px",
                  fontSize: { xs: "20px", md: "36px" },
                  lineHeight: "54px",
                  color: "rgba(0, 227, 165, 1)",
                }}
              >
                20K+
              </Typography>
              <Typography
                sx={{
                  fontWeight: "400px",
                  fontSize:{xs:"9px",md:"18px"},
                  lineHeight: "27px",
                  color: "rgba(158, 158, 158, 1)",
                }}
              >
                Build Community
              </Typography>
            </Box>
          </Stack>
          <Box
          component="img"
            src={global}
            sx={{width:"100%"}}
          ></Box>
          <Stack
            direction="row"
            spacing="14%"
            sx={{
              backgroundColor: "#0B1512",
              padding: "60px 20px",
              borderRadius: "50px",
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
            }}
          >
            <Typography
              sx={{ color: "#093428", fontSize: "24px", fontWeight: "700" }}
            >
              Coinbase
            </Typography>
            <Typography
              sx={{ color: "#093428", fontSize: "24px", fontWeight: "700" }}
            >
              BLOCKCHAIN.COM
            </Typography>
            <Typography
              sx={{ color: "#093428", fontSize: "24px", fontWeight: "700" }}
            >
              <img src={binance} alt="img" />
              Binance
            </Typography>
            <Typography
              sx={{ color: "#093428", fontSize: "24px", fontWeight: "700" }}
            >
              <img src={met} alt="img" />
              BITMEX
            </Typography>
          </Stack>
        </Container>
      </Box>
    </>
  );
};

export default Map;
